import type { AgentSummary } from '../lib/types';
import { InspectIcon, PlusIcon } from './Icons';

interface HeaderProps {
  apiBase: string;
  agents: AgentSummary[];
  agentId: string;
  connection: 'checking' | 'online' | 'offline';
  threadId: string;
  busy: boolean;
  onAgentChange: (id: string) => void;
  onNewThread: () => void;
  onOpenInspector: () => void;
}

export function Header(props: HeaderProps) {
  let host = props.apiBase;
  try { host = new URL(props.apiBase).hostname; } catch { /* Keep the configured value. */ }
  return (
    <header className="app-header">
      <div className="brand-lockup" aria-label="Mastra Run Console">
        <span className="brand-mark" aria-hidden="true"><i /><i /><i /></span>
        <span>
          <strong>Mastra</strong>
          <small>run console</small>
        </span>
      </div>

      <div className="connection-strip" title={props.apiBase}>
        <span className={`connection-dot ${props.connection}`} />
        <span>{props.connection === 'checking' ? 'Connecting' : props.connection === 'online' ? 'Brain online' : 'Brain unavailable'}</span>
        <code>{host}</code>
      </div>

      <div className="header-actions">
        <label className="agent-picker">
          <span>Agent</span>
          <select
            aria-label="Agent"
            value={props.agentId}
            onChange={(event) => props.onAgentChange(event.target.value)}
            disabled={props.busy}
          >
            {props.agents.map((agent) => <option key={agent.id} value={agent.id}>{agent.name}</option>)}
          </select>
        </label>
        <span className="thread-chip" title={props.threadId}>thread/{props.threadId.slice(0, 8)}</span>
        <button className="icon-button mobile-inspect" type="button" onClick={props.onOpenInspector} aria-label="Open run inspector">
          <InspectIcon />
        </button>
        <button className="new-thread-button" type="button" onClick={props.onNewThread} disabled={props.busy} aria-label="New thread">
          <PlusIcon />
          <span>New thread</span>
        </button>
      </div>
    </header>
  );
}
